import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../Components/Layout/Layout';
import { getProductRef } from '../firebase/collections';
import { formatPrice } from '../utils/formatters';
import { useTranslatedName } from '../Components/PostCards/useTranslatedName';
import { conditionKey } from '../data/categories';
import './Compare.css';

function CompareCard({ product }) {
  const { t } = useTranslation();
  const name = useTranslatedName(product);
  return (
    <div className="compareCard">
      <Link to={`/ad/${product.id}`} className="compareCardImage">
        <img src={product.images?.[0] || product.url} alt="" />
      </Link>
      <h3 className="compareCardTitle">{name}</h3>
      <p className="compareCardPrice">{formatPrice(product.price, product)}</p>
      <p className="compareCardMeta">
        {product.category}
        {product.condition && ` · ${t(`conditions.${conditionKey(product.condition)}`)}`}
      </p>
      <Link to={`/ad/${product.id}`}>{t('admin.viewAd')}</Link>
    </div>
  );
}

function Compare() {
  const { t } = useTranslation();
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ids = location.search
      ? new URLSearchParams(location.search).get('ids')?.split(',').slice(0, 3) || []
      : location.state?.ids?.slice(0, 3) || [];
    if (ids.length === 0) {
      setLoading(false);
      return;
    }
    Promise.all(ids.map((id) => getProductRef(id.trim()).get()))
      .then((docs) => {
        setProducts(
          docs
            .filter((d) => d.exists)
            .map((d) => ({ id: d.id, ...d.data() }))
        );
      })
      .finally(() => setLoading(false));
  }, [location.search, location.state]);

  return (
    <Layout>
      <div className="comparePage">
        <h1>{t('admin.compareAds')}</h1>
        {loading ? (
          <p>{t('admin.loading')}</p>
        ) : products.length === 0 ? (
          <p>{t('admin.addAdIds')}</p>
        ) : (
          <div className="compareGrid">
            {products.map((p) => (
              <CompareCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Compare;
